import { useOkapiKy } from '@folio/stripes/core';
import { useMutation } from 'react-query';
export var useCancelRefresh = function (_a) {
    var listId = _a.listId, _b = _a.onSuccess, onSuccess = _b === void 0 ? function () { } : _b, _c = _a.onError, onError = _c === void 0 ? function () { } : _c;
    var ky = useOkapiKy();
    var _d = useMutation(function () { return ky["delete"]("lists/".concat(listId, "/refresh")); }, { onError: onError, onSuccess: onSuccess }), cancelRefresh = _d.mutate, cancelInProgress = _d.isLoading;
    return { cancelRefresh: cancelRefresh, cancelInProgress: cancelInProgress };
};
